import { render, staticRenderFns } from "./StudentWithdrawForm.vue?vue&type=template&id=4050626a"
import script from "./StudentWithdrawForm.vue?vue&type=script&lang=js"
export * from "./StudentWithdrawForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports